import { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import Boton from '../../components/Boton'
import { erpApi } from '../../api/erp'
import { fmtFecha } from '../../utils/fecha'
import { mensajeError, fmtImporte, st } from './_helpers'
import { BuscadorTercero, CajaError } from './_comun'
import { colors, space } from '../../design/tokens'

const fecha = (s) => (s && String(s).includes('/')) ? s : fmtFecha(s)

/** EMP 900 · Cuenta corriente de un tercero (cliente o proveedor): saldo, pendientes y resumen con saldo corrido. */
export default function Emp900CuentaPage() {
  const [params] = useSearchParams()
  const [tipo, setTipo] = useState(params.get('tipo') === 'proveedor' ? 'proveedor' : 'cliente')
  const [tercero, setTercero] = useState(null)
  const [cuenta, setCuenta] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const elegirTercero = (t) => { setTercero(t); setCuenta(null); setError('') }
  const elegirTipo = (t) => { setTipo(t); setCuenta(null); setError('') }
  useEffect(() => {
    if (!tercero) return
    let vigente = true
    setLoading(true)
    erpApi.cuenta(tercero.id, tipo)
      .then(({ data }) => { if (vigente) setCuenta(data) })
      .catch(e => { if (vigente) setError(mensajeError(e)) })
      .finally(() => { if (vigente) setLoading(false) })
    return () => { vigente = false }
  }, [tercero, tipo])

  const saldo = Number(cuenta?.saldo || 0)

  return (
    <div>
      <div style={st.header}><h2 style={st.title}>Cuentas corrientes</h2></div>
      <p style={st.sub}>Saldo positivo = {tipo === 'cliente' ? 'nos debe' : 'le debemos'} · negativo = saldo a favor.</p>

      <div style={st.filtros}>
        <div style={{ display: 'flex', gap: space.lg }}>
          <label style={st.check}><input type="radio" checked={tipo === 'cliente'} onChange={() => elegirTipo('cliente')} /> Cliente</label>
          <label style={st.check}><input type="radio" checked={tipo === 'proveedor'} onChange={() => elegirTipo('proveedor')} /> Proveedor</label>
        </div>
        <div style={{ flex: 1, minWidth: 320 }}><BuscadorTercero value={tercero} onChange={elegirTercero} rol={tipo} /></div>
        {tercero && <Boton variante="ghost" onClick={() => elegirTercero(null)}>Limpiar</Boton>}
      </div>

      <CajaError>{error}</CajaError>
      {!tercero && <p style={st.info}>Elegí un {tipo} para ver su cuenta.</p>}
      {loading && <p style={st.info}>Consultando el ERP…</p>}

      {cuenta && (
        <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 2fr)', gap: space.lg, alignItems: 'start' }}>
          <div style={{ ...st.seccion, minWidth: 0 }}>
            <div style={st.card}>
              <div style={st.cardTitulo}>Saldo</div>
              <div style={{ ...st.saldoGrande, color: saldo > 0 ? colors.text : saldo < 0 ? colors.ok : colors.textSec }}>{fmtImporte(cuenta.saldo)}</div>
              <div style={st.info}>{cuenta.tercero?.codigo} · {cuenta.tercero?.razon_social}</div>
            </div>
            <div style={st.card}>
              <div style={st.cardTitulo}>Pendientes de {tipo === 'cliente' ? 'cobro' : 'pago'}</div>
              {cuenta.pendientes?.length === 0 ? <p style={{ ...st.info, margin: 0 }}>Nada pendiente.</p> : (
                <table style={st.table}>
                  <thead><tr><th style={st.th}>Documento</th><th style={st.th}>Fecha</th><th style={{ ...st.th, textAlign: 'right' }}>Importe</th><th style={{ ...st.th, textAlign: 'right' }}>Pendiente</th></tr></thead>
                  <tbody>
                    {cuenta.pendientes.map(p => (
                      <tr key={p.id} style={st.tr}>
                        <td style={st.tdMono}>{p.documento}</td>
                        <td style={st.tdFecha}>{fecha(p.fecha)}</td>
                        <td style={st.tdImporte}>{fmtImporte(p.importe)}</td>
                        <td style={st.tdImporte}>{fmtImporte(p.pendiente)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
          <div style={{ ...st.card, minWidth: 0 }}>
            <div style={st.cardTitulo}>Resumen de cuenta</div>
            <div style={{ overflow: 'auto' }}>
              <table style={st.table}>
                <thead><tr><th style={st.th}>Fecha</th><th style={st.th}>Documento</th><th style={{ ...st.th, textAlign: 'right' }}>Debe</th><th style={{ ...st.th, textAlign: 'right' }}>Haber</th><th style={{ ...st.th, textAlign: 'right' }}>Saldo</th></tr></thead>
                <tbody>
                  {(cuenta.resumen || []).length === 0 && <tr><td colSpan={5} style={st.empty}>Sin movimientos.</td></tr>}
                  {(cuenta.resumen || []).map((m, i) => (
                    <tr key={i} style={st.tr}>
                      <td style={st.tdFecha}>{fecha(m.fecha)}</td>
                      <td style={st.tdMono}>{m.documento}</td>
                      <td style={st.tdImporte}>{Number(m.debe) ? fmtImporte(m.debe) : ''}</td>
                      <td style={st.tdImporte}>{Number(m.haber) ? fmtImporte(m.haber) : ''}</td>
                      <td style={st.tdImporte}>{fmtImporte(m.saldo)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
